// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"508":"b0106e80","881":"1c7f6229"}[chunkId] + ".chunk.js";
};